import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {loadHome} from '../../../store/actions/home';
import {getHomeData} from '../../../store/reducers';
import {mobileMediaQuery, useIsWeb} from '../../../styles';
import ContentRow from '../../ContentRow';
import VideosGrid from '../../VideosGrid';
import {webMediaQuery} from '../../../styles';
import {useHistory} from 'react-router-dom';
import {debugCNitoUrl} from '../../../helpers';

const SearchEmtpy = () => {
    const homeRows = useSelector(getHomeData);
    const dispatch = useDispatch();
    const releases =
        homeRows?.filter(row => row.title === 'RELEASES')[0].vods.slice(0, 6) ||
        [];
    const {t} = useTranslation();
    const isWeb = useIsWeb();
    const history = useHistory();

    useEffect(() => {
        if (homeRows === null) {
            dispatch(loadHome());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onOpenVideo = video => {
        history.push(`/play/${video}${debugCNitoUrl()}`);
    };

    return (
        <Container>
            <BorderedTitle>{t('search.noResultAlert')}</BorderedTitle>
            <Characters />
            <Gradient />
            <Title>{t('search.noResultTitle')}</Title>
            {releases && <VideoTitle>{t('search.checkLatest')}</VideoTitle>}
            {!isWeb && (
                <VideosGrid items={releases} onClickItem={onOpenVideo} />
            )}
            {isWeb && (
                <StyledRow
                    title=""
                    titleAlign="left"
                    items={releases}
                    onClickContent={onOpenVideo}
                    sendEvents
                />
            )}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 100%;
`;

const BorderedTitle = styled.div`
    font-family: TTNormsProExtraBlack;
    font-size: 101px;
    height: 900;
    text-shadow: 1px 1px 0 white, -1px 1px 0 white, 1px -1px 0 white,
        -1px -1px 0 white;
    color: #211921;
    margin-bottom: -90px;
    text-transform: uppercase;

    ${mobileMediaQuery} {
        font-size: 65px;
        margin-bottom: -60px;
    }
`;

const Characters = styled.img.attrs({
    src: require('../../../assets/search-empty.png'),
})`
    margin-bottom: -3px;
    ${mobileMediaQuery} {
        width: 186px;
    }
`;

const Gradient = styled.div`
    width: 466px;
    height: 3px;
    background: radial-gradient(
        50% 50% at 50% 50%,
        #ed0080 0%,
        #fde113 53.65%,
        rgba(196, 196, 196, 0) 100%
    );
`;

const Title = styled.div`
    font-family: AvenirNextRoundedStd;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    text-align: center;
    margin-top: 27px;
`;

const VideoTitle = styled.div`
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-weight: 900;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    text-transform: uppercase;

    color: #ffffff;
    margin-top: 60px;
    margin-bottom: 16px;
    ${webMediaQuery} {
        align-self: flex-start;
    }
`;

const StyledRow = styled(ContentRow)`
    padding: 0px 0px !important;
`;

export default SearchEmtpy;
